<main class="pagina-publica">
  <section class="modal-pagamento" aria-label="Pagamento de fatura avulsa">
    <header class="topo-promokit">
      <img src="/assets/fidelidade/promokit-horizontal-branco.png" alt="Promokit">
      <span><i class="fa fa-lock" aria-hidden="true"></i> Pagamento seguro dentro do Promokit</span>
    </header>

    <div class="cartao-pagamento">
      <div class="carregando" *ngIf="carregando"><i class="k-icon k-i-loading"></i> Carregando fatura...</div>
      <div class="alert alert-danger" *ngIf="erro">{{erro}}</div>

      <ng-container *ngIf="dados">
        <header class="empresa-cabecalho">
          <img *ngIf="dados.empresa?.logo" [src]="dados.empresa.logo" [alt]="'Logo de ' + dados.empresa?.nome">
          <div>
            <h2>{{dados.empresa?.nome}}</h2>
            <p class="empresa-endereco" *ngIf="dados.empresa?.endereco">
              <i class="fa fa-map-marker-alt" aria-hidden="true"></i> {{dados.empresa.endereco}}
            </p>
          </div>
        </header>
        <app-fatura-detalhes [fatura]="fatura"></app-fatura-detalhes>

        <div class="alert alert-success" *ngIf="fatura.status === 'Paga'">Pagamento confirmado.</div>
        <div class="alert alert-warning" *ngIf="estadoFinal && fatura.status !== 'Paga'">
          Esta fatura está {{fatura.status | lowercase}} e não está disponível para pagamento.
        </div>

        <ng-container *ngIf="pagavel">
          <div class="abas-pagamento">
            <button type="button" *ngIf="fatura.pix?.disponivel" (click)="forma = 'pix'" [class.ativa]="forma === 'pix'">
              <i class="fa fa-qrcode" aria-hidden="true"></i> Pix
            </button>
            <button type="button" *ngIf="fatura.permiteCartao" (click)="forma = 'cartao'" [class.ativa]="forma === 'cartao'">
              <i class="fa fa-credit-card" aria-hidden="true"></i> Cartão
            </button>
          </div>
          <app-pagamento-pix-fatura *ngIf="forma === 'pix' && fatura.pix?.disponivel" [pix]="fatura.pix"></app-pagamento-pix-fatura>
          <div *ngIf="fatura.pix && !fatura.pix.disponivel" class="alert alert-info">O Pix expirou. Você ainda pode pagar com cartão.</div>
          <section class="autenticacao-3ds" *ngIf="forma === 'cartao' && urlAutenticacao3DSSegura">
            <h3>Autentique o cartão</h3>
            <p>Conclua a validação solicitada pelo banco emissor. O pagamento será confirmado depois da autorização.</p>
            <iframe [src]="urlAutenticacao3DSSegura" title="Autenticação 3D Secure"></iframe>
            <a [href]="urlAutenticacao3DS" target="_blank" rel="noopener">Abrir autenticação em outra janela</a>
          </section>
          <div class="alert alert-info" *ngIf="forma === 'cartao' && pagamentoCartaoPendente && !urlAutenticacao3DSSegura">
            Pagamento enviado. Aguardando a confirmação do banco.
          </div>
          <cad-cartaocredito #cartaoComponent *ngIf="forma === 'cartao' && fatura.permiteCartao && !pagamentoCartaoPendente"
            [modoPublico]="true" [provedorPagamento]="'cellcoin'"
            [parcelamento]="{numeroParcelas: fatura.maxParcelas, total: fatura.total}"
            [textoBotao]="'Pagar fatura'" (onCriou)="pagueComCartao($event)"></cad-cartaocredito>
          <button type="button" class="btn btn-link" [disabled]="processando" (click)="sincronize()">Já paguei / Atualizar status</button>
        </ng-container>
      </ng-container>
    </div>
  </section>
</main>
